import { gql } from "@apollo/client";
import { ProjectContext } from "context/ProjectProvider";
import { FeatureTypes } from "entity-app/constants";
import { DELETE_FEATURE_INSTANCE } from "entity-app/graphQL/ciq-feature-mutations";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { getFeatureEntityLog } from "services/feature-apis";

function useSubmittalTrackedData() {
  const { projectId } = useParams() as { projectId: string };
  const { gqlClientForProject, tokenRetrievalState } =
    useContext(ProjectContext);

  const [mutationDeleteSubmittal] = useCIQMutation(
    gql(DELETE_FEATURE_INSTANCE),
    {
      client: gqlClientForProject
    }
  );

  const [entityList, setEntityList] = useState<any>(null);
  const [entityListLoading, setEntityListLoading] = useState(false);
  const [entityListLoadedOnce, setEntityListLoadedOnce] = useState(false);

  const fetchLogData = useCallback(async () => {
    setEntityListLoading(true);
    const res = await getFeatureEntityLog({
      projectToken: tokenRetrievalState?.token,
      featureType: FeatureTypes.SUBMITTALS,
      is_tracked: false
    });
    if (res.success) {
      setEntityList([...res.data]);
      setEntityListLoadedOnce(true);
    }
    setEntityListLoading(false);
  }, [tokenRetrievalState?.token]);

  useEffect(() => {
    if (projectId && tokenRetrievalState?.token) {
      fetchLogData();
    }
    return () => {};
  }, [fetchLogData, projectId, tokenRetrievalState?.token]);

  return {
    entityList,
    entityListLoading,
    entityListLoadedOnce,
    fetchLogData,
    mutationDeleteSubmittal
  };
}

export default useSubmittalTrackedData;
